import script from "./JoinUs.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinUs.vue?vue&type=script&setup=true&lang=js"

import "./JoinUs.vue?vue&type=style&index=0&id=5e44bb4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e44bb4d"]])

export default __exports__